import React, { Component } from "react";

import { Link } from 'react-router-dom';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Grid from '@material-ui/core/Grid';
//import ProdConfTranslation from "./ProdConfTranslation.js";
import CustomerConfOdoo from "./CustomerConfOdoo.js";
import CustomerProductsList from "./CustomerProductsList.js";
import SupplierConfiguration from "./SupplierConfiguration.js";
import PublishIcon from '@material-ui/icons/Publish';
import Tooltip from '@material-ui/core/Tooltip';
import Icon from '@material-ui/core/Icon';

class CustomerForm extends Component {
	constructor() {
		super();
		
		this.handleCheckboxPdf = this.handleCheckboxPdf.bind(this);
		this.handleCheckboxMatch100 = this.handleCheckboxMatch100.bind(this);
		this.handleCheckboxGaleradaComptaParaules = this.handleCheckboxGaleradaComptaParaules.bind(this);
		this.listPMs = this.listPMs.bind(this);
		this.handleDocument = this.handleDocument.bind(this);
		this.renderDocuments = this.renderDocuments.bind(this);
		this.renderUploadFile = this.renderUploadFile.bind(this);
		//this.sortDocuments = this.sortDocuments.bind(this);
	}
	
	handleCheckboxPdf(e){
		this.props.setParallelTextPdf(e.target.checked ? 1:0);
	}
	
	handleCheckboxMatch100(e){
		this.props.setIgnoreMatch100(e.target.checked ? 1:0);
	}
	handleCheckboxGaleradaComptaParaules(e){
		this.props.setGaleradaComptaParaules(e.target.checked ? 1:0);
	}
	
	listPMs(acc, cur){
		if(typeof(cur.projectManager) !== "undefined"){
			let pm = cur.projectManager.split(",");
			if(pm.reduce((acc2, cur2) => acc2 || (parseInt(cur2)===this.props.customer.id), false)){
			//if(pm.includes(cur.id+"")){
				if(acc.length>0){
					acc += ","
				}
				return acc+cur.username;
			}else{
				return acc;
			}
		}
		return acc;
	}
	
	//sortDocuments(a, b){
	//	return a.filename.localeCompare(b.filename);
	//}
	
	renderDocuments(){
		let documents = [];
		documents = this.props.customer.documentation.sort( (a,b) => a.filename.localeCompare(b.filename)).map( attachment => <li><a target="_blank" href={process.env.REACT_APP_serverURL+"/documents-0.0.1/document/"+attachment.id+"/content?access_token="+this.props.accessToken}>{attachment.filename}</a>    <Tooltip title="Delete"><Icon style={{ fontFamily: "tipoecl", fontSize: "21px", color: "#c0392b", cursor: "pointer"}} onClick={() => { this.props.handleRemoveDocument(this.props.customer.id, attachment.id); }}>&#59421;</Icon></Tooltip></li>);
		//var linkKeys = Object.keys(this.props.customer.links);
		//if(linkKeys){
			//<a target="_blank" href={this.props.xlfDocument.href+"/content?access_token="+this.props.accessToken} title={this.props.xlfDocument.title}><Icon style={{ fontFamily: "tipoecl", fontSize: "21px", color: "#27ae60", cursor: "pointer"}}>&#59408;</Icon></a>
			//documents = linkKeys.filter(k => this.props.customer.links[k]!=='self').map( attachmentK => <li><a target="_blank" href={this.props.customer.links[attachmentK].href+"/content?access_token="+this.props.accessToken}>{attachmentK}</a></li>);
		//}
		return <ul>{documents}</ul>;
	}
	
	renderUploadFile(){
		if(this.props.processing){
			return <Grid item xs={12}>PROCESSING....</Grid>
		}
		return <Grid container item direction="row" alignItems="stretch" justify="flex-start" xs={12}>
					<Grid item xs={12}>
					<h3>Documentation:</h3>
					</Grid>
					<Grid item xs={6}>
						<div>
							<Button label="Choose Document" component="span">
								<input type="file" name="docuemnt" style={{ overflow: 'hidden' }} onChange={this.handleDocument}/>
							</Button>
						</div>
					</Grid>
				</Grid>
	}
	
	handleDocument(e){
		e.preventDefault();
		this.props.handleDocument(this.props.customer.id, e.target.files[0]);
	}
	
	render() {
		let manager = Object.values(this.props.users).reduce(this.listPMs, "");
		if(manager.length<1){
			manager = "Eduard";
		};
		return (
			<div class="contentM">
			<form 
				action={this.props.action}
				method={this.props.method}
				onSubmit={this.onSubmit}
			>
				<Grid container item direction="row" alignItems="center" justify="center" spacing={0}>
					<Grid item xs={12}>
						<h1>{this.props.customer.name}</h1>
					</Grid>
					<Grid item xs={12}>
						Project Manager: {manager}
					</Grid>
					<Grid container item direction="row" xs={12} justify="flex-start">
						<Grid item xs={3}>
						<FormControlLabel 
								control={
									<Checkbox
										checked={this.props.customer.parallelTextPdf}
										value="sec_1"
										color="primary"
										onChange={this.handleCheckboxPdf}
									/>
								}
								label="PDF original / translated"
							/>
						</Grid>
						<Grid item xs={3}>
						<FormControlLabel 
								control={
									<Checkbox
										checked={this.props.customer.galeradaComptaParaules}
										value="sec_2"
										color="primary"
										onChange={this.handleCheckboxGaleradaComptaParaules}
									/>
								}
								label="Galerada compta paraules"
							/>
						</Grid>
						<Grid item xs={3}>
						<FormControlLabel 
								control={
									<Checkbox
										checked={this.props.customer.ignoreMatch100}
										value="sec_2"
										color="primary"
										onChange={this.handleCheckboxMatch100}
									/>
								}
								label="Ignore Match100 Translator"
							/>
						</Grid>
					</Grid>
					<Grid item xs={12}>
					<CustomerProductsList
						id={this.props.customer.id}
						products={this.props.customer.product}
						supplierConfig={this.props.supplierConfig}
						users={this.props.users}
						langPairs={this.props.langPairs}
						tmxRecords={this.props.tmxRecords}
						morePriority={this.props.morePriority}
						changConfig={this.props.changConfig}
						glosaris={this.props.glosaris}
						accessToken={this.props.accessToken}
					/>
					</Grid>
					<Grid item xs={12}>
					<CustomerConfOdoo
						activeSpecialized={this.props.customer.activeSpecialized}
						specialized={this.props.customer.specialized}
						activeUrgent={this.props.customer.activeUrgent}
						activeAttachment={this.props.customer.activeAttachment}
						seeSuppliers={this.props.customer.seeSuppliers}
					/>
					</Grid>
				</Grid>
			</form>
			<Grid container item direction="row" alignItems="center" justify="flex-start" spacing={0}>
				<Grid item xs={6}>
					<h5>Customer user configurations:</h5>
					<SupplierConfiguration
						id={this.props.customer.id}
						products={this.props.customer.product}
						supplierConfig={this.props.supplierConfig}
						users={this.props.users}
						langPairs={this.props.langPairs}
						addSupplierConfig = {this.props.addSupplierConfig}
					/>
				</Grid>
			</Grid>
			<Grid container item direction="row" alignItems="center" justify="center" spacing={0}>
				<Grid item xs={12}>
				{this.renderUploadFile()}
				</Grid>
				<Grid item xs={12}>
				{this.renderDocuments()}
				</Grid>
			</Grid>
			</div>
		);
	}
}

export default CustomerForm;